import { __awaiter } from "tslib";
import { Logger } from '@as-react/logger';
import { default as scriptLoaderUtil } from './ScriptLoaderUtil';
class KlarnaUtil {
    static init(_a) {
        return __awaiter(this, arguments, void 0, function* ({ token, url, key }) {
            yield scriptLoaderUtil
                .loadScript(url, key, true)
                .then(() => {
                window.Klarna.Payments.init({ client_token: token });
            })
                .catch(Logger.logError);
        });
    }
    static load(container, payment_method_categories, instance_id, cb) {
        window.Klarna.Payments.load({ container, payment_method_categories, instance_id }, cb);
    }
    static authorize(payment_method_categories, instance_id, cb) {
        window.Klarna.Payments.authorize({ payment_method_categories, instance_id }, cb);
    }
}
export default KlarnaUtil;
